// extracted by mini-css-extract-plugin
module.exports = {"electionsNav":"electionsNav___3CJ3i"};